export const connectionValueRules = [
  {
    apparatus: "FX",
    valid_connections: [
      {
        type: "C + D or higher",
        cv_bonus: 0.1
      },
      {
        type: "D + D",
        cv_bonus: 0.1
      },
      {
        type: "D + E or higher",
        cv_bonus: 0.2
      }
    ],
    notes: "Only acrobatic series (forward or backward). Non-acrobatic to acrobatic connections are not eligible."
  },
  {
    apparatus: "PH",
    valid_connections: [
      {
        type: "D + D",
        cv_bonus: 0.1
      },
      {
        type: "D + E or higher",
        cv_bonus: 0.2
      }
    ],
    notes: "Between flairs/circles or traveling elements only. No CV for scissors or single leg swings."
  },
  {
    apparatus: "PL",
    valid_connections: [
      {
        type: "D + D",
        cv_bonus: 0.1
      },
      {
        type: "D + E or higher",
        cv_bonus: 0.2
      }
    ],
    notes: "Between flairs/circles or traveling elements only (pommelless). No CV for scissors or single leg swings."
  },
  {
    apparatus: "SR",
    valid_connections: [
      {
        type: "C + D or higher",
        cv_bonus: 0.1
      },
      {
        type: "D + D",
        cv_bonus: 0.1
      },
      {
        type: "D + E or higher",
        cv_bonus: 0.2
      }
    ],
    notes: "Between swing elements or strength to swing. No CV for strength to strength or two dismounts."
  },
  {
    apparatus: "PB",
    valid_connections: [
      {
        type: "C + D or higher",
        cv_bonus: 0.1
      },
      {
        type: "D + D",
        cv_bonus: 0.1
      },
      {
        type: "D + E or higher",
        cv_bonus: 0.2
      }
    ],
    notes: "Swing elements, Hechts, underswings, or combinations only."
  },
  {
    apparatus: "HB",
    valid_connections: [
      {
        type: "C + D or higher",
        cv_bonus: 0.1
      },
      {
        type: "D + D",
        cv_bonus: 0.1
      },
      {
        type: "D + E or higher",
        cv_bonus: 0.2
      }
    ],
    notes: "Between flight elements or between Group I and III elements. No CV for repeated flight or swing to strength."
  },
  {
    apparatus: "VT",
    valid_connections: [],
    notes: "No connection bonuses. Vaults scored individually."
  }
];
